import PrimaryHeader from "../component/PrimaryHeader";
const AppHeader = () => { return (<PrimaryHeader />) }
export default AppHeader;